(() => {
    window.Dashboard = window.Dashboard || {};
    window.Dashboard.Models = window.Dashboard.Models || {};

    class InboxTemplate {
        TemplateId = 0;
        Name = "";
        Description = "";
        Content = undefined;

        initialiseInboxTemplate(inboxTemplate) {
            return _.extend(this, inboxTemplate);
        }
    }
    window.Dashboard.Models.InboxTemplate = InboxTemplate;
})();
